
import _ from 'lodash';
import Uploader from '@/components/Uploader/index.vue';

export default {
  name: 'FileUploader',

  componentName: 'FileUploader',

  components: {
    Uploader: Uploader
  },

  props: {
    config: {
      type: Object,
      required: true
    },
    formValue: {
      type: Object,
      required: true
    }
  },

  data: function data() {
    return {
      loading: false,
      fileList: []
    };
  },


  computed: {
    isMultiple: function isMultiple() {
      if (this.config && this.config.params) {
        return this.config.params.multiple;
      }
      return false;
    }
  },

  watch: {
    'config.params.fileList': {
      handler: function handler(val) {
        this.fileList = val;
      },

      deep: true
    }
  },

  mounted: function mounted() {
    if (_.get(this.config, 'params.fileList')) {
      this.fileList = _.get(this.config, 'params.fileList');
    }
  },


  methods: {
    handleBeforeUpload: function handleBeforeUpload(file) {
      // 当是单个file上传的话，清空参数，避免上传中就点击提交，
      !this.isMultiple && (this.formValue[this.config.prop] = '');
      if (this.config.beforeUpload) {
        return this.config.beforeUpload(file);
      }
      return true;
    },
    handleUploadChange: function handleUploadChange(file, fileList) {
      // 当是单个file上传的话，清空选项
      if (!this.isMultiple && fileList.length > 1) {
        fileList.splice(0, 1);
      }
    },
    handleRemove: function handleRemove(file, fileList) {
      // 批量上报场景需要业务自己处理remove场景
      this.config.handleRemove && this.config.handleRemove(file, fileList);
    },
    handleUploadError: function handleUploadError(erro, file, fileList) {
      fileList = [];
    },
    handleUploadSuccess: function handleUploadSuccess(response, file, fileList) {
      var _this = this;

      // 当是singlefile的场景
      if (!this.isMultiple) {
        if (response.code === 0) {
          fileList[0].name = response.data.origin_name;
          fileList[0].url = response.data.file_path;
          this.fileList = fileList;
          this.formValue[this.config.prop] = response.data.file_path;
        } else {
          this.$message({
            message: response.msg ? response.msg : '上传失败，请重新尝试',
            type: 'warning'
          });
          setTimeout(function () {
            _this.fileList = [];
            _this.formValue[_this.config.prop] = '';
            _this.$refs.uploader.clearFiles();
          });
        }
        this.config.handleUploadSuccess && this.config.handleUploadSuccess(response, file, fileList);
      } else {
        // 批量上报场景需要业务自己处理返回场景
        this.config.handleUploadSuccess && this.config.handleUploadSuccess(response, file, fileList);
      }
    },
    handleClickPreview: function handleClickPreview(file) {
      if (file.response && file.response.data && file.response.data.url) {
        window.open(file.response.data.url);
      } else {
        window.open(file.url);
      }
    }
  }
};